<template>
  <div class="message-popup">
    <transition-group name="list-complete">
      <div class="el-notification" role="alert" v-for="item in allTCmessage" :key="item.id" v-show="true">
        <i class="el-notification__icon el-icon-warning"></i>
        <div class="el-notification__group is-with-icon">
          <h2 class="el-notification__title">重要通知</h2>
          <div class="el-notification__content">
            <p>{{ item.title }}</p>
            <div
              class="look-details"
              @click="goToDetails(item)"
              v-stat="{ id : 'jsfdzx_tcgg_ckxq_click',
                      app_id: 'HFS_FD_YW',
                      currentTime: +new Date()}"
            >查看详情</div>
          </div>
          <div class="el-notification__closeBtn el-icon-close" @click="closeNotification(item)" v-stat="{ id : 'jsfdzx_tcgg_gbtc_click',
                      app_id: 'HFS_FD_YW',
                      currentTime: +new Date()}"></div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import VueSocketIO from 'vue-socket.io';
export default {
  data() {
    return {
      newMessageList: [], // 后台推送过来的消息集合
      maxRetryCount: 5,
      retryCount: 0,
      closedMessageList: []
    };
  },
  computed: {
    ...mapState({
        allMessageList: state => state.message.allMessageList
    }),
    allTCmessage() {
      let ret = [];
      if (this.allMessageList.length > 0) {
          let allTC = this.allMessageList.filter(item => {
              return item.type === 'notification' && !item.isClose;
          });
          let allUnread = allTC.filter(item => {
              return !item.read;
          });
          ret = allUnread.filter(item => {
              return item.notifyHideTime - Date.parse(new Date()) > 0;
          });
      }
       return [...this.newMessageList, ...ret].filter(item => {
          return !this.closedMessageList.includes(item.id);
        });
    }
  },
  mounted() {
    this.socketInterval = setInterval(() => {
      if (this.retryCount < this.maxRetryCount) {
        this.initSocket();
      } else {
        clearInterval(this.socketInterval);
      }
      this.retryCount++;
    }, 1500);
  },
  beforeDestroy() {
    clearInterval(this.socketInterval);
    this.socket && this.socket.io.close();
  },
  methods: {
    ...mapMutations(['ADD_MESSAGE', 'GET_MESSAGE_LIST']),
    goToDetails(message) {
      this.closeNotification(message, true);
      let { href } = this.$router.resolve({name: 'messageCenter@details', query: {id: message.id}});
      window.open(href, '_blank');
    },
    closeNotification(message, read) {
      if (!message.notifyHideTime) {
        this.newMessageList.forEach((item, index) => {
          if (item.id === message.id) {
            this.newMessageList.splice(index, 1);
            this.closedMessageList.push(message.id);
          }
        });
        if (!read) {
          return;
        }
      }
      this.allMessageList.forEach((item, index) => {
        if (item.id === message.id) {
          if (read) {
            item.read = read;
          } else {
            item.isClose = true;
            this.closedMessageList.push(message.id);
          }
          this.$set(this.allMessageList, index, item);
        }
      });
    },
    handleNewMessage(data) {
      this.newMessageList.unshift(data);
      this.ADD_MESSAGE(data);
    },
    handleAuthSuccess() {
      this.socket.emitter.addListener('new-message', this.handleNewMessage, this);
    },
    handleAuthFail() {
      console.log('socket鉴权失败！');
    },
    initSocket() {
      let socket = null;
      try {
        socket = new VueSocketIO({
          debug: process.env.NODE_ENV !== 'production',
          connection: `${feConfig.api.socket}`
        });
      } catch (e) {
        console.log('socket初始化失败');
        clearInterval(this.socketInterval);
        return;
      }
      this.socket = socket;
      this.authSocket();
    },
    authSocket() {
      let messageToken = window.sessionStorage.getItem('message_token');
      if (messageToken) {
        this.socket.emitter.addListener('auth-success', this.handleAuthSuccess, this);
        this.socket.emitter.addListener('auth-fail', this.handleAuthFail, this);
        this.socket.io.emit('auth', {token: messageToken});
        clearInterval(this.socketInterval);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.message-popup {
    position: fixed;
    overflow: hidden;
    width: 330px;
    top: 60px;
    right: 16px;
    z-index: 999;

    .el-notification {
        position: relative;
        margin-bottom: 16px;

        .el-notification__group {
            width: 100%;

            .el-notification__title {
                line-height: 24px;
            }
        }
    }

    .look-details {
        font-size: 12px;
        color: #1a90ff;
        text-align: right;
        cursor: pointer;
    }
}

.list-complete-enter,
.list-complete-leave-to {
    opacity: 0;
    transform: translateX(100%);
}

.animate {
    position: absolute;
    top: 0;
    left: 0;
    transition: 1s;
    opacity: 0;
    transform: translateX(100%);
}

.up-animate {
    transition: 1s 1s;
    transform: translateY(-100%);
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/common/MessagePopup.vue